import { render, staticRenderFns } from "./SystemComponents.vue?vue&type=template&id=2a74a2a0&"
import script from "./SystemComponents.vue?vue&type=script&lang=js&"
export * from "./SystemComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports